import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import {
  ApiResponseReader,
  ApiResponseService,
} from '../api/api-response.service';

@Injectable({
  providedIn: 'root',
})
export class ChartOfAccountService {
  // This api version is needed for agent 2
  private readonly apiVersion: string = `v1/coa/`;

  constructor(
    private apiService: ApiService,
    private apiResponseService: ApiResponseService
  ) {}

  getCoaProject(projectId: string): Observable<ApiResponseReader> {
    const slug: string = `${this.apiVersion}` + `${projectId}`;
    return this.apiResponseService.prepareResponseForReading(
      this.apiService.get(slug, {}, '')
    );
  }

  getMappingIndexes(): Observable<ApiResponseReader> {
    const slug: string = `${this.apiVersion}` + `index`;
    return this.apiResponseService.prepareResponseForReading(
      this.apiService.get(slug, {}, '')
    );
  }

  undoPostCoaStart(tb: string, index: string): Observable<void> {
    const slug: string = `${this.apiVersion}` + `start-undo`;

    const formData = new FormData();
    formData.append('tb', tb);
    formData.append('index', index);

    return this.apiService.post(slug, formData, '');
  }

  postCoaStart(
    tb: string,
    file: File | null,
    index: string
  ): Observable<ApiResponseReader> {
    const slug: string = `${this.apiVersion}` + `start`;
    const formData = new FormData();
    formData.append('tb', tb);
    formData.append('index', index);

    if (file) {
      formData.append('file', file);
    }

    return this.apiResponseService.prepareResponseForReading(
      this.apiService.post(slug, formData, '')
    );
  }

  putLevel1Project(
    projectId: string,
    file: File | null
  ): Observable<ApiResponseReader> {
    const slug: string = `${this.apiVersion}` + `${projectId}/lvl1`;

    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      return this.apiResponseService.prepareResponseForReading(
        this.apiService.put(slug, '', formData, '')
      );
    }

    return this.apiResponseService.prepareResponseForReading(
      this.apiService.put(slug, '', {}, '')
    );
  }
}
